import React from "react"

import {Deal, DealRedemption, PaymentCurrencyType} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"
import {FormattedCurrency} from "@irati/utils/lang"
import ItemAvatar, {ItemAvatarProps} from "./ItemAvatar"

type Props = Required<Pick<Deal & DealRedemption, "cardImage" | "header">> & {
  price?: number,
  productImgOpts?: Omit<ItemAvatarProps, "src">
}

const SummaryProductInfo = ({cardImage, header, price, productImgOpts = {
  medium: true
}}: Props) => (
  <Flex gap={theme.spacing.two} alignItems="center">
    <ItemAvatar src={cardImage} {...productImgOpts} />
    <div>
      <Body>{header}</Body>
      {price ? (
        <Body weight="bold" marginTop={theme.spacing.one}>
          <FormattedCurrency isCents currency={PaymentCurrencyType.Rp} value={price} />
        </Body>
      ) : null}
    </div>
  </Flex>
)

export default SummaryProductInfo
